import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const MINUTES_AGO = [2, 3, 4, 6, 7, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimeout: number;
    let hideTimeout: number;
    const cycle = (delay: number) => {
      showTimeout = window.setTimeout(() => {
        setVisible(true);
        hideTimeout = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % recentBuyers.length);
          cycle(9000);
        }, 5200);
      }, delay);
    };
    cycle(6000);
    return () => {
      window.clearTimeout(showTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const buyer = recentBuyers[index];
  const minutes = MINUTES_AGO[index % MINUTES_AGO.length];
  return <AnimatePresence data-id="element-41" data-mp="117fs87nqy3tz">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.26,
      ease: [0.23, 1, 0.32, 1]
    }} className="pointer-events-auto fixed left-3 top-3 z-40 w-[min(21rem,calc(100vw-1.5rem))] sm:left-5 sm:top-auto sm:bottom-5" role="status" aria-live="polite" data-id="element-42" data-mp="116mh6uhr8s61">
          <div className="flex items-start gap-3 rounded-2xl border border-[#0E3B42]/10 bg-white p-3.5 shadow-[0_18px_40px_-18px_rgba(14,59,66,0.4)]" data-id="element-43" data-mp="x51axrzq7c4t">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#EEF6F7]" data-id="element-44" data-mp="s4wpronvht89">
              <CheckCircle2Icon className="h-5 w-5 text-[#17808D]" aria-hidden="true" data-id="element-45" data-mp="28mkh9t8lrv7l" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-46" data-mp="2apctl5hq1bkk">
              <p className="text-[13.5px] font-bold leading-snug text-[#0E3B42]" data-id="element-47" data-mp="2aqntgu81pz6e">
                {buyer.name}
              </p>
              <p className="mt-0.5 text-[12.5px] leading-snug text-[#4A6B70]" data-id="element-48" data-mp="2kn0opwj8ol39">
                ha appena acquistato il Percorso Clinico GLP-1™
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.06em] text-[#8A9EA1]" data-id="element-49" data-mp="2pl2e0z79dgn6">
                {buyer.place} · {minutes} min fa
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="-mr-1 -mt-1 rounded-md p-1 text-[#8A9EA1] transition-colors duration-150 ease-out hover:bg-[#F3EDE3] hover:text-[#0E3B42]" data-id="element-50" data-mp="1wxod6q0fw0xs">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="197bymwaov5y8" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}